import { makeStyles } from '@material-ui/core';

export const visualizacaoContratoStyles = makeStyles({
  iconText: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  icon: {
    padding: '5px',
    color: '#43a047',
  },
});
